import { render, staticRenderFns } from "./CareEdit.vue?vue&type=template&id=fa1dce86&scoped=true&"
import script from "./CareEdit.vue?vue&type=script&lang=js&"
export * from "./CareEdit.vue?vue&type=script&lang=js&"
import style0 from "./CareEdit.vue?vue&type=style&index=0&id=fa1dce86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1dce86",
  null
  
)

export default component.exports